import moment from 'moment';

/**
 * Wer darf eine Notiz bearbeiten oder löschen — und woran sieht man, dass sie
 * bearbeitet wurde?
 *
 * Beide Regeln standen bis zum 28.08.2026 inline im `CaseNotesTab` und
 * NIRGENDWO sonst. Genau das war das Problem, das B4 der Runde 28.08. löst
 * (Auftrag Alex): die Kunden-Notizen im CRM-Tab und im Kunden-Dialog zeigten
 * dieselben Notizen an, boten aber kein Bearbeiten — wer sich im Fall
 * vertippt hatte, konnte es dort korrigieren, im Kunden-Bereich nicht.
 *
 * 🔥 DIE REGEL WIRD GETEILT, NICHT KOPIERT. Sie besteht aus zwei Bedingungen,
 * die leicht auseinanderlaufen, wenn man sie zweimal schreibt:
 *
 * 1. **Nur die EIGENE Notiz.** Fremde Notizen bleiben unangetastet — eine
 *    Notiz ist die Aussage ihres Verfassers, nicht ein gemeinsames Feld.
 * 2. **Keine importierte.** Eine aus HubSpot gespiegelte Notiz (`is_imported`)
 *    gehört dort hin: eine Änderung in BW würde beim nächsten Sync
 *    überschrieben und sähe bis dahin aus, als sei sie angekommen.
 *
 * Das Backend prüft dasselbe noch einmal (NotePolicy) — diese Funktion sagt
 * nur, was die Oberfläche anbietet. Ein ausgeblendeter Knopf ist keine Regel.
 */
export interface NotizRechteEingabe {
  user_id?: number | null;
  is_imported?: boolean | null;
  created_at: string;
  updated_at?: string | null;
}

export const darfNotizVerwalten = (
  note: NotizRechteEingabe,
  currentUserId?: number | null,
): boolean => currentUserId != null && currentUserId === note.user_id && !note.is_imported;

/**
 * „bearbeitet"-Marker: `updated_at` liegt nach `created_at`.
 *
 * Bewusst am Zeitstempel und nicht an einem eigenen Flag — die Notiz-Tabelle
 * führt keins, und ein zweiter Wahrheitsträger könnte dem ersten widersprechen.
 * Fehlt `updated_at` (Alt-Bestand aus dem Import), gilt die Notiz als
 * unbearbeitet.
 */
export const istNotizBearbeitet = (note: NotizRechteEingabe): boolean =>
  !!note.updated_at && moment(note.updated_at).isAfter(moment(note.created_at));
